// src/components/GeneralServices.js
import React from 'react';
import './Generalservise.css';

// एक ही image सभी cards के लिए
import ServiceImage from '../../../imgs/general.webp';

const Generalservise = () => {
    const services = [
        {
            title: 'High Precision Molding',
            description: 'Accurate and efficient molding solutions for complex plastic products.'
        },
        // {
        //   title: 'Automated Systems',
        //   description: 'Fully automated injection systems for mass production efficiency.'
        // },
        // {
        //   title: 'Custom Machine Design',
        //   description: 'Tailored injection molding machines to meet your unique production needs.'
        // }
    ];

    return (
        <div className="container-1">
            <h2 className="services-title"> General Services</h2>
            <div className="services-grid-1">
                {services.map((service, index) => (
                    <div className="gen-service-card" key={index}>
                        <div>
                            <img src={ServiceImage} alt="Service" className="service-image"  data-aos="fade-down"/>

                        </div>
                        <div className="service-content"data-aos="fade-down">
                            <h3 className="service-heading">{service.title}</h3>
                            <p className="service-description">{service.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Generalservise;
